<template>
  <div id="app">
    <button class="hamburger hamburger--squeeze" type="button" @click.prevent="toggleMenu()" id="hamburger" v-if="getPage !== '/'">
        <span class="hamburger-box">
        <span class="hamburger-inner"></span>
      </span>
    </button>
    <div id="navigation-mobile" v-if="getPage !== '/' && getRouteName !== 'resetPassword'">
      <router-link :to="{ name: 'dashboard' }" class="link">Tableau de bord</router-link>
      <router-link v-if="isAdmin() || isAgent()" :to="{ name: 'enedisCase' }" @click.native="clickEnedisCase()" class="link">Création / Édition affaire</router-link>
      <router-link :to="{ name: 'statistics' }" class="link">Statistiques</router-link>
      <router-link v-if="isAdmin()" :to="{ name: 'admin' }" class="link">Liste des agents</router-link>
      <router-link v-if="isAdmin()" :to="{ name: 'gaps' }" class="link">Aléas</router-link>
      <router-link v-if="isAdmin()" :to="{ name: 'case-managers' }">Chargés d'affaire</router-link>
      <router-link :to="{ name: 'profile' }" class="link">Mon profil</router-link>
      <router-link :to="{ name: 'logout' }" class="link">Se déconnecter</router-link>
    </div>

    <div id="navigation" v-if="getPage !== '/' && getRouteName !== 'resetPassword'">
      <div class="link-group">
        <div class="logo">
          <router-link :to="{ name: 'dashboard' }"><img src="/static/img/logo/logo.svg"></router-link>
        </div>

        <router-link :to="{ name: 'dashboard' }" class="link"><svg class="picto" viewBox="0 0 48.64 38.37" style="enable-background:new 0 0 48.64 38.37;"><circle class="st3" cx="4.61" cy="4.06" r="1"/><path class="st3" d="M8.65,5.06c0.55,0,1-0.45,1-1s-0.45-1-1-1c-0.55,0-1,0.45-1,1S8.09,5.06,8.65,5.06z"/><circle class="st3" cx="12.68" cy="4.06" r="1"/><path class="st3" d="M45.79,0H2.85C1.28,0,0,1.28,0,2.85v32.67c0,1.57,1.28,2.85,2.85,2.85h42.94c1.57,0,2.85-1.28,2.85-2.85V2.85
        C48.64,1.28,47.36,0,45.79,0z M2.85,1.7h42.94c0.63,0,1.15,0.52,1.15,1.15v3.54H1.7V2.85C1.7,2.22,2.22,1.7,2.85,1.7z M1.7,35.52
        V8.08h8.23v28.58H2.85C2.22,36.67,1.7,36.15,1.7,35.52z M45.79,36.67H11.64V8.08h35.3v27.43C46.94,36.15,46.42,36.67,45.79,36.67z"
        /><path class="st3" d="M4.08,13.61h3.39c0.47,0,0.85-0.38,0.85-0.85s-0.38-0.85-0.85-0.85H4.08c-0.47,0-0.85,0.38-0.85,0.85
        S3.61,13.61,4.08,13.61z"/><path class="st3" d="M15.29,13.61h7.96c0.47,0,0.85-0.38,0.85-0.85s-0.38-0.85-0.85-0.85h-7.96c-0.47,0-0.85,0.38-0.85,0.85
        S14.82,13.61,15.29,13.61z"/><path class="st3" d="M7.46,17.36H4.08c-0.47,0-0.85,0.38-0.85,0.85s0.38,0.85,0.85,0.85h3.39c0.47,0,0.85-0.38,0.85-0.85
        S7.93,17.36,7.46,17.36z"/><path class="st3" d="M7.46,22.8H4.08c-0.47,0-0.85,0.38-0.85,0.85s0.38,0.85,0.85,0.85h3.39c0.47,0,0.85-0.38,0.85-0.85
        S7.93,22.8,7.46,22.8z"/><path class="st3" d="M43.87,17.36H15.29c-0.47,0-0.85,0.38-0.85,0.85v12.51c0,0.47,0.38,0.85,0.85,0.85h28.58
        c0.47,0,0.85-0.38,0.85-0.85V18.21C44.72,17.74,44.34,17.36,43.87,17.36z M43.02,19.05v2.47H16.14v-2.47H43.02z M43.02,23.23v2.47
        H16.14v-2.47H43.02z M16.14,29.87V27.4h26.88v2.47H16.14z"/></svg>Tableau de bord</router-link>

        <router-link v-if="isAdmin() || isAgent()" :to="{ name: 'enedisCase' }" @click.native="clickEnedisCase()" class="link"><svg class="picto" viewBox="0 0 48.69 41.18" style="enable-background:new 0 0 48.69 41.18;"><path class="st3" d="M48.69,13.32C48.69,5.97,42.71,0,35.37,0c-5.69,0-10.54,3.59-12.45,8.62h-3.26l-2.68-3.82
        c-0.16-0.23-0.42-0.36-0.7-0.36H2.58c-1.35,0-2.44,1.09-2.44,2.44v31.22c-0.23,0.68-0.17,1.41,0.21,2
        c0.43,0.68,1.18,1.06,2.04,1.06h32.3c1.55,0,2.02-1.03,2.39-2.13l5.76-14.7C46.36,21.95,48.69,17.9,48.69,13.32z M2.58,6.15h13.26
        l2.68,3.82c0.16,0.23,0.42,0.36,0.7,0.36h3.18c-0.22,0.96-0.35,1.96-0.35,2.99c0,0.9,0.09,1.78,0.26,2.63H10.36
        c-1.66,0-2.18,1.52-2.39,2.13L1.84,33.73V6.89C1.84,6.48,2.17,6.15,2.58,6.15z M35.47,38.46c-0.34,1.01-0.44,1.01-0.79,1.01H2.38
        c-0.27,0-0.49-0.1-0.61-0.28c-0.11-0.17-0.12-0.4,0-0.66l7.79-19.86c0.35-1.02,0.57-1.02,0.79-1.02h12.43
        c1.8,5.22,6.75,8.99,12.58,8.99c1.82,0,3.56-0.37,5.14-1.03L35.47,38.46z M35.37,24.94c-6.41,0-11.62-5.21-11.62-11.62
        S28.96,1.7,35.37,1.7s11.62,5.21,11.62,11.62S41.78,24.94,35.37,24.94z"/><path class="st3" d="M41.6,12.47h-5.38V7.08c0-0.47-0.38-0.85-0.85-0.85s-0.85,0.38-0.85,0.85v5.38h-5.38
        c-0.47,0-0.85,0.38-0.85,0.85s0.38,0.85,0.85,0.85h5.38v5.38c0,0.47,0.38,0.85,0.85,0.85s0.85-0.38,0.85-0.85v-5.38h5.38
        c0.47,0,0.85-0.38,0.85-0.85S42.07,12.47,41.6,12.47z"/></svg>Création<br>Édition affaire</router-link>

        <router-link :to="{ name: 'statistics' }" class="link"><svg class="picto" viewBox="0 0 48.7 41.41" style="enable-background:new 0 0 48.7 41.41;" xml:space="preserve"><path class="st3" d="M48.45,37.67l-2.26-2.26c-0.33-0.33-0.87-0.33-1.2,0c-0.33,0.33-0.33,0.87,0,1.2l0.83,0.83H3.98V2.91L4.8,3.74
        c0.17,0.17,0.38,0.25,0.6,0.25s0.44-0.08,0.6-0.25c0.33-0.33,0.33-0.87,0-1.2L3.72,0.25c-0.33-0.33-0.87-0.33-1.2,0L0.25,2.51
        c-0.33,0.33-0.33,0.87,0,1.2c0.33,0.33,0.87,0.33,1.2,0l0.83-0.83v35.4c0,0.47,0.38,0.85,0.85,0.85h42.66l-0.83,0.83
        c-0.33,0.33-0.33,0.87,0,1.2c0.17,0.17,0.38,0.25,0.6,0.25s0.44-0.08,0.6-0.25l2.29-2.29C48.78,38.54,48.78,38,48.45,37.67z"/><path class="st3" d="M10.46,31.44c2.09,0,3.79-1.7,3.79-3.78c0-1.07-0.45-2.04-1.17-2.73l5.1-7.59c0.57,0.34,1.23,0.55,1.94,0.55
        c0.92,0,1.76-0.34,2.42-0.9l5.27,5.27c-0.45,0.62-0.73,1.39-0.73,2.21c0,2.09,1.7,3.78,3.79,3.78c2.09,0,3.79-1.7,3.79-3.78
        c0-0.95-0.36-1.8-0.94-2.46l6.31-8.59c0.33,0.09,0.67,0.16,1.03,0.16c2.09,0,3.79-1.7,3.79-3.79s-1.7-3.79-3.79-3.79
        s-3.79,1.7-3.79,3.79c0,1.11,0.49,2.1,1.26,2.79L32.34,21c-0.46-0.2-0.96-0.31-1.49-0.31c-0.64,0-1.24,0.18-1.77,0.46l-5.52-5.52
        c0.21-0.47,0.33-0.98,0.33-1.53c0-2.09-1.7-3.79-3.79-3.79c-2.09,0-3.79,1.7-3.79,3.79c0,0.75,0.23,1.44,0.6,2.03l-5.33,7.93
        c-0.36-0.12-0.74-0.2-1.14-0.2c-2.09,0-3.79,1.7-3.79,3.79S8.38,31.44,10.46,31.44z M41.05,7.71c1.15,0,2.08,0.94,2.08,2.09
        s-0.94,2.09-2.08,2.09s-2.08-0.94-2.08-2.09S39.9,7.71,41.05,7.71z M32.94,24.48c0,1.15-0.94,2.08-2.09,2.08s-2.08-0.94-2.08-2.08
        c0-0.59,0.25-1.13,0.65-1.51c0.06-0.04,0.12-0.06,0.17-0.12c0.02-0.02,0.03-0.04,0.04-0.06c0.34-0.25,0.76-0.4,1.22-0.4
        C32.01,22.39,32.94,23.32,32.94,24.48z M20.11,12.02c1.15,0,2.09,0.94,2.09,2.09c0,1.15-0.94,2.08-2.09,2.08s-2.08-0.94-2.08-2.08
        C18.03,12.95,18.96,12.02,20.11,12.02z M10.46,25.57c1.15,0,2.09,0.94,2.09,2.09c0,1.15-0.94,2.08-2.09,2.08s-2.08-0.94-2.08-2.08
        C8.38,26.5,9.31,25.57,10.46,25.57z"/></svg>Statistiques</router-link>

        <router-link v-if="isAdmin()" :to="{ name: 'admin' }" class="link"><svg class="picto" viewBox="0 0 47 41.21" style="enable-background:new 0 0 47 41.21;" xml:space="preserve"><path class="st0" d="M46.91,38.02l-1.86-6.48c-0.04-0.13-0.13-0.27-0.22-0.35c-1.15-3.5-3.99-6.21-7.59-7.14l-0.53-0.09
        c-0.8-0.22-1.69,0.04-2.26,0.71c-1.95,2.22-4.44,2.4-7.05,2.4s-5.1-0.18-7.05-2.4c-0.58-0.67-1.46-0.93-2.26-0.71l-0.53,0.13
        c-2.71,0.71-5.01,2.44-6.48,4.75H5.47c-0.04,0-0.04,0-0.09-0.04c0-0.04-0.04-0.09-0.04-0.18l1.15-4.13
        c1.02-3.24,2.97-4.21,6.79-5.19c0.18-0.04,0.31-0.13,0.4-0.22c0.31,0.27,0.67,0.49,1.02,0.67c0.13,0.09,0.27,0.09,0.4,0.09
        c0.31,0,0.62-0.18,0.8-0.49c0.22-0.44,0.04-0.98-0.4-1.2c-2.04-1.06-3.5-4.08-3.5-7.19c0-2.75,2.26-5.01,5.01-5.01
        c0.53,0,1.02,0.09,1.51,0.22c-0.49,1.2-0.75,2.48-0.75,3.86c0,7.59,4.57,13.97,9.98,13.97c5.32,0,10.03-6.52,10.03-13.97
        C37.77,4.48,33.29,0,27.74,0c-3.5,0-6.61,1.82-8.38,4.57c-0.75-0.27-1.55-0.4-2.35-0.4c-2.4,0-4.52,1.29-5.72,3.19
        c-0.09-0.09-0.18-0.13-0.27-0.18C10.35,6.83,9.69,6.7,8.93,6.7c-2.48-0.04-4.48,1.95-4.48,4.44c0,1.42,0.4,2.75,1.02,3.81
        c-2.04,0.53-3.86,1.33-4.7,4.04l-0.71,2.57c-0.13,0.44-0.04,0.93,0.22,1.29c0.27,0.4,0.75,0.62,1.24,0.62h3.42
        C4.9,23.64,4.81,23.82,4.76,24l-1.15,4.17c-0.18,0.58-0.04,1.2,0.35,1.69c0.35,0.49,0.89,0.75,1.51,0.75h4.7
        c-0.13,0.31-0.22,0.62-0.31,0.93L8,38.06c-0.18,0.75-0.04,1.55,0.44,2.17s1.2,0.98,1.95,0.98h26.62h1.51h5.99
        c0.75,0,1.51-0.35,1.95-0.98C46.95,39.61,47.13,38.82,46.91,38.02z M20.42,6.3c0.04-0.04,0.09-0.09,0.13-0.18
        c0.04-0.04,0.04-0.13,0.09-0.18c1.38-2.48,4.04-4.17,7.1-4.17c3.68,0,6.79,2.44,7.85,5.77c-1.55,0.31-3.19-0.31-4.17-1.64
        c-0.31-0.4-0.84-0.49-1.24-0.18C30,5.86,29.92,5.99,29.87,6.17c-0.04,0.04-0.04,0.09-0.09,0.13c-1.24,2.53-5.41,3.59-10.16,2.66
        C19.76,8.03,20.02,7.14,20.42,6.3z M22.91,11.05c3.55,0,6.48-1.11,7.98-3.19c1.11,0.98,2.48,1.51,3.95,1.51
        c0.35,0,0.75-0.04,1.11-0.13c0.04,0.27,0.04,0.49,0.04,0.75c0,6.52-3.86,12.24-8.25,12.24c-4.21,0-7.9-5.28-8.21-11.49
        C20.69,10.96,21.84,11.05,22.91,11.05z M1.88,21.69l0.62-2.22c0.53-1.82,1.64-2.35,3.86-2.88c0.13-0.04,0.27-0.09,0.35-0.18
        c0.22,0.18,0.4,0.31,0.67,0.44c0.13,0.09,0.27,0.09,0.4,0.09c0.31,0,0.62-0.18,0.8-0.49c0.22-0.44,0.04-0.98-0.35-1.2
        c-1.15-0.62-2-2.35-2-4.13c0-1.51,1.2-2.71,2.71-2.71c0.49,0,0.89,0.09,1.29,0.31c0.13,0.04,0.22,0.09,0.35,0.09
        c-0.22,0.67-0.35,1.38-0.35,2.13c0,2.53,0.84,5.01,2.17,6.74c-2.66,0.67-5.01,1.55-6.57,3.99L1.88,21.69L1.88,21.69z
          M45.09,39.17c-0.09,0.09-0.27,0.27-0.58,0.27h-5.99h-1.51H10.4c-0.31,0-0.49-0.18-0.58-0.27c-0.13-0.18-0.18-0.44-0.13-0.62
        l1.86-6.48c0.89-3.06,3.33-5.46,6.43-6.25l0.53-0.13c0.13-0.04,0.35,0.04,0.49,0.18c2.44,2.79,5.46,3.02,8.38,3.02
        s5.94-0.22,8.38-3.02c0.13-0.13,0.31-0.22,0.53-0.18l0.53,0.13c3.06,0.8,5.55,3.19,6.43,6.25l0.8,2.75
        c0.04,0.13,0.09,0.22,0.18,0.31l0.98,3.37C45.26,38.73,45.22,38.99,45.09,39.17z"/></svg>Liste des agents</router-link>

        <router-link v-if="isAdmin()" :to="{ name: 'gaps' }" class="link"><svg class="picto" viewBox="0 0 45.7 44.9" style="enable-background:new 0 0 45.7 44.9;" xml:space="preserve"><path class="st0" d="M44.9,6.5h-3.6V0.8c0-0.4-0.4-0.8-0.8-0.8s-0.8,0.4-0.8,0.8v5.7h-3.6c-0.4,0-0.8,0.4-0.8,0.8V18
          c0,0.4,0.4,0.8,0.8,0.8h3.6v25.4c0,0.4,0.4,0.8,0.8,0.8s0.8-0.4,0.8-0.8V18.8h3.6c0.4,0,0.8-0.4,0.8-0.8V7.3
          C45.7,6.9,45.4,6.5,44.9,6.5z M44.1,17.2h-7.3V8.1h7.3V17.2z"/>
        <path class="st0" d="M38.3,11.2c0,0.4,0.4,0.8,0.8,0.8h2.8c0.4,0,0.8-0.4,0.8-0.8s-0.4-0.8-0.8-0.8h-2.8
          C38.6,10.4,38.3,10.7,38.3,11.2z"/>
        <path class="st0" d="M41.9,13.4h-2.8c-0.4,0-0.8,0.4-0.8,0.8s0.4,0.8,0.8,0.8h2.8c0.4,0,0.8-0.4,0.8-0.8S42.4,13.4,41.9,13.4z"/>
        <path class="st0" d="M27.3,24.7h-3.6V0.8c0-0.4-0.4-0.8-0.8-0.8s-0.8,0.4-0.8,0.8v23.9h-3.6c-0.4,0-0.8,0.4-0.8,0.8v10.7
          c0,0.4,0.4,0.8,0.8,0.8h3.6v7.2c0,0.4,0.4,0.8,0.8,0.8s0.8-0.4,0.8-0.8v-7.2h3.6c0.4,0,0.8-0.4,0.8-0.8V25.5
          C28.1,25,27.8,24.7,27.3,24.7z M26.5,35.3h-7.3v-9.1h7.3V35.3z"/>
        <path class="st0" d="M20.7,29.3c0,0.4,0.4,0.8,0.8,0.8h2.8c0.4,0,0.8-0.4,0.8-0.8s-0.4-0.8-0.8-0.8h-2.8
          C21,28.5,20.7,28.8,20.7,29.3z"/>
        <path class="st0" d="M24.3,31.5h-2.8c-0.4,0-0.8,0.4-0.8,0.8s0.4,0.8,0.8,0.8h2.8c0.4,0,0.8-0.4,0.8-0.8S24.7,31.5,24.3,31.5z"/>
        <path class="st0" d="M9.7,13.4H6V0.8C6,0.4,5.7,0,5.2,0S4.4,0.4,4.4,0.8v12.6H0.8c-0.4,0-0.8,0.4-0.8,0.8v10.7
          c0,0.4,0.4,0.8,0.8,0.8h3.6v18.5c0,0.4,0.4,0.8,0.8,0.8S6,44.6,6,44.1V25.6h3.6c0.4,0,0.8-0.4,0.8-0.8V14.2
          C10.5,13.7,10.1,13.4,9.7,13.4z M8.9,24H1.6V15h7.3V24z"/>
        <path class="st0" d="M3,18c0,0.4,0.4,0.8,0.8,0.8h2.8c0.4,0,0.8-0.4,0.8-0.8s-0.4-0.8-0.8-0.8H3.8C3.4,17.2,3,17.5,3,18z"/>
        <path class="st0" d="M6.7,20.2H3.8C3.4,20.2,3,20.5,3,21s0.4,0.8,0.8,0.8h2.8c0.4,0,0.8-0.4,0.8-0.8S7.1,20.2,6.7,20.2z"/></svg>Aléas</router-link>

        <router-link v-if="isAdmin()" :to="{ name: 'case-managers' }" class="link"><svg class="picto" viewBox="0 0 47 47.4" style="enable-background:new 0 0 47 47.4;" xml:space="preserve"><path class="st0" d="M46.9,44.2L45,37.8c0-0.1-0.1-0.3-0.2-0.4c-1.2-3.5-4-6.2-7.6-7.1l-0.5-0.1c-0.8-0.2-1.7,0-2.3,0.7
          c-2,2.2-4.4,2.4-7.1,2.4s-5.1-0.2-7.1-2.4c-0.6-0.7-1.5-0.9-2.3-0.7l-0.5,0.1c-2.7,0.7-5.1,2.5-6.5,4.7H5.5c0,0,0,0-0.1,0
          c0,0,0-0.1,0-0.2l1.2-4.1c1-3.2,3-4.2,6.8-5.2c0.2,0,0.3-0.1,0.4-0.2c0.3,0.3,0.7,0.5,1,0.7c0.1,0.1,0.3,0.1,0.4,0.1
          c0.3,0,0.6-0.2,0.8-0.5c0.2-0.4,0-1-0.4-1.2c-2-1.1-3.5-4.1-3.5-7.2c0-2.6,2.1-4.8,4.7-5c0,0.1,0,0.3,0,0.4V13
          c-1,0.3-1.8,1.2-1.8,2.3c0,1.3,1.1,2.4,2.4,2.4h0.5c0.5,6.9,4.8,12.5,9.9,12.5c5,0,9.4-5.7,9.9-12.5h0.5c1.3,0,2.4-1.1,2.4-2.4
          c0-1.1-0.8-2-1.8-2.3v-0.3c0-5.1-3.5-9.4-8.2-10.7V0.8c0-0.4-0.4-0.8-0.8-0.8h-4.2c-0.4,0-0.8,0.4-0.8,0.8v1.1c-4,1.1-7.1,4.4-8,8.5
          c-2.4,0-4.4,1.3-5.6,3.2c-0.1-0.1-0.2-0.1-0.3-0.2c-0.7-0.4-1.3-0.5-2.1-0.5c-2.5,0-4.5,2-4.5,4.4c0,1.4,0.4,2.8,1,3.8
          c-2,0.5-3.9,1.3-4.7,4l-0.7,2.6c-0.1,0.4,0,0.9,0.2,1.3c0.3,0.4,0.8,0.6,1.2,0.6h3.4c0,0.2-0.1,0.4-0.2,0.5l-1.2,4.2
          c-0.2,0.6,0,1.2,0.4,1.7c0.4,0.5,0.9,0.8,1.5,0.8h4.7l0.2-0.4c-0.3,0.6-0.5,1.1-0.5,1.3C9.8,38.1,8,44.3,8,44.3
          c-0.2,0.8,0,1.6,0.4,2.2s1.2,1,2,1H37h1.5h6c0.8,0,1.5-0.4,2-1C46.9,45.8,47.1,45,46.9,44.2z M27.7,28.5c-4,0-7.6-4.9-8.1-10.7h16.3
          C35.4,23.6,31.8,28.5,27.7,28.5z M38.2,16.1H17.3c-0.5,0-0.8-0.4-0.8-0.8s0.4-0.8,0.8-0.8h20.9c0.5,0,0.8,0.4,0.8,0.8
          S38.7,16.1,38.2,16.1z M37.3,12.6v0.2h-6.6V3.6C34.5,4.8,37.3,8.4,37.3,12.6z M24.9,3.6v6.9c0,0.4,0.4,0.8,0.8,0.8s0.8-0.4,0.8-0.8
          V1.6h2.6v11.3H18.3v-0.2C18.3,8.4,21,4.8,24.9,3.6z M1.9,27.9l0.6-2.2c0.5-1.8,1.6-2.4,3.9-2.9c0.1,0,0.3-0.1,0.4-0.2
          c0.2,0.2,0.4,0.3,0.7,0.4c0.1,0.1,0.3,0.1,0.4,0.1c0.3,0,0.6-0.2,0.8-0.5c0.2-0.4,0-1-0.4-1.2c-1.2-0.6-2-2.4-2-4.1
          c0-1.5,1.2-2.7,2.7-2.7c0.5,0,0.9,0.1,1.3,0.3c0.1,0,0.2,0.1,0.4,0.1c-0.2,0.7-0.4,1.4-0.4,2.1c0,2.5,0.8,5,2.2,6.7
          c-2.7,0.7-5,1.6-6.6,4H1.9z M45.1,45.4c-0.1,0.1-0.3,0.3-0.6,0.3h-6H37H10.4c-0.3,0-0.5-0.2-0.6-0.3c-0.1-0.2-0.2-0.4-0.1-0.6
          l1.9-6.5c0.9-3.1,3.3-5.5,6.4-6.3l0.5-0.1c0.1,0,0.4,0,0.5,0.2c2.4,2.8,5.5,3,8.4,3c2.9,0,5.9-0.2,8.4-3c0.1-0.1,0.3-0.2,0.5-0.2
          l0.5,0.1c3.1,0.8,5.5,3.2,6.4,6.3l0.8,2.8c0,0.1,0.1,0.2,0.2,0.3l1,3.4C45.3,45,45.2,45.2,45.1,45.4z"/>
        </svg>Chargés d'affaire</router-link>
    </div>

    <div class="link-group">
      <router-link :to="{ name: 'profile' }" class="link"><svg class="picto" viewBox="0 0 25.22 31.6" style="enable-background:new 0 0 25.22 31.6;" xml:space="preserve"><path class="st3" d="M12.61,0C5.66,0,0,5.66,0,12.61v15.08c0,2.16,1.76,3.92,3.91,3.92s3.91-1.76,3.91-3.92V26
      c0-0.24,0.19-0.43,0.43-0.43S8.69,25.77,8.69,26v1.68c0,2.16,1.76,3.92,3.94,3.92c2.16,0,3.91-1.76,3.91-3.92V26
      c0-0.24,0.19-0.43,0.43-0.43s0.43,0.19,0.43,0.43v1.68c0,2.16,1.76,3.92,3.91,3.92s3.91-1.76,3.91-3.92V12.61
      C25.22,5.66,19.56,0,12.61,0z M23.62,27.68c0,1.28-1.04,2.32-2.31,2.32s-2.31-1.04-2.31-2.32V26c0-1.12-0.91-2.03-2.03-2.03
      s-2.03,0.91-2.03,2.03v1.68c0,1.28-1.04,2.32-2.33,2.32c-1.28,0-2.32-1.04-2.32-2.32V26c0-1.12-0.91-2.03-2.03-2.03
      S6.23,24.88,6.23,26v1.68c0,1.28-1.04,2.32-2.31,2.32S1.6,28.96,1.6,27.68V12.61C1.6,6.54,6.54,1.6,12.61,1.6
      s11.01,4.94,11.01,11.01V27.68z"/><path class="st3" d="M17.44,7.48c-1.83,0-3.37,1.23-3.86,2.91c-0.03,0.07-0.06,0.14-0.07,0.21c-0.07,0.3-0.12,0.61-0.12,0.93
      c0,0.32,0.05,0.63,0.12,0.93c0.01,0.08,0.04,0.15,0.07,0.22c0.5,1.67,2.03,2.9,3.86,2.9c2.23,0,4.05-1.82,4.05-4.05
      S19.67,7.48,17.44,7.48z M15.56,12.34c-0.18,0-0.34-0.08-0.48-0.19c-0.05-0.2-0.09-0.41-0.09-0.63s0.04-0.43,0.09-0.63
      c0.14-0.11,0.3-0.19,0.48-0.19c0.45,0,0.81,0.37,0.81,0.81S16.01,12.34,15.56,12.34z M17.44,13.98c-0.4,0-0.77-0.11-1.11-0.28
      c0.9-0.32,1.55-1.17,1.55-2.17c0-1.01-0.65-1.85-1.55-2.17c0.33-0.17,0.71-0.28,1.11-0.28c1.35,0,2.45,1.1,2.45,2.45
      C19.89,12.88,18.79,13.98,17.44,13.98z"/><path class="st3" d="M7.59,7.48c-1.83,0-3.37,1.23-3.86,2.91c-0.03,0.07-0.06,0.14-0.07,0.21c-0.07,0.3-0.12,0.61-0.12,0.93
      c0,0.32,0.05,0.63,0.12,0.93c0.01,0.08,0.04,0.15,0.07,0.22c0.5,1.67,2.03,2.9,3.86,2.9c2.23,0,4.05-1.82,4.05-4.05
      S9.83,7.48,7.59,7.48z M5.72,12.34c-0.18,0-0.34-0.08-0.48-0.19c-0.05-0.2-0.09-0.41-0.09-0.63s0.04-0.43,0.09-0.63
      c0.14-0.11,0.3-0.19,0.48-0.19c0.45,0,0.81,0.37,0.81,0.81S6.17,12.34,5.72,12.34z M7.59,13.98c-0.4,0-0.77-0.11-1.11-0.28
      c0.9-0.32,1.55-1.17,1.55-2.17c0-1.01-0.65-1.85-1.55-2.17c0.33-0.17,0.71-0.28,1.11-0.28c1.35,0,2.45,1.1,2.45,2.45
      C10.04,12.88,8.94,13.98,7.59,13.98z"/></svg>Mon profil</router-link>

      <router-link :to="{ name: 'logout' }" class="link"><svg class="picto" viewBox="0 0 25.82 31.7" style="enable-background:new 0 0 25.82 31.7;" xml:space="preserve"><path class="st3" d="M19.3,7.56c-0.41-0.24-0.93-0.09-1.16,0.32s-0.09,0.93,0.32,1.16c3.5,1.99,5.67,5.73,5.67,9.75
      c0,6.18-5.03,11.21-11.21,11.21S1.7,24.97,1.7,18.79c0-4.02,2.17-7.75,5.67-9.75c0.41-0.23,0.55-0.75,0.32-1.16
      S6.93,7.33,6.53,7.56C2.5,9.86,0,14.16,0,18.79C0,25.91,5.79,31.7,12.91,31.7s12.91-5.79,12.91-12.91
      C25.82,14.16,23.32,9.86,19.3,7.56z"/><path class="st3" d="M12.91,18.82c1.45,0,2.64-1.18,2.64-2.64V2.64c0-1.45-1.18-2.64-2.64-2.64s-2.64,1.18-2.64,2.64v13.55
      C10.27,17.64,11.46,18.82,12.91,18.82z M11.98,2.64c0-0.52,0.42-0.94,0.94-0.94s0.94,0.42,0.94,0.94v13.55
      c0,0.52-0.42,0.94-0.94,0.94s-0.94-0.42-0.94-0.94V2.64z"/></svg>Se déconnecter</router-link>
      </div>
    </div>

    <b-container fluid
                 class="app-content-container"
                 :class="{'app-content-container-with-nav': getPage !== '/'}">
      <router-view/>
      <!-- Absolute component which display toast -->
      <GlobalToaster />
      <!-- Absolute component which display spinner and block events while it disappears -->
      <GlobalSpinner />
    </b-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import AuthService from './services/AuthService';

export default {
  name: 'App',
  components: { },
  data() {
    return {
    };
  },
  beforeMount() {
  },
  mounted() {
    console.log('App VUE !');
  },
  computed: {
    getPage() {
      return this.$store.state.route.path;
    },
    getRouteName() {
      return this.$store.state.route.name;
    }
  },
  methods: {
    ...mapGetters([
      'getUserSession',
      'getUsers',
      'getAgencies',
      'isAdmin',
      'isAgent',
    ]),
    ...mapActions([
      'logout',
      'getMe',
      'fetchAgencies',
    ]),
    clickEnedisCase() {
      this.$store.commit('setEnedisCaseOnGoing', null);
    },
    /**
     * Custom menu
     * Handling of event: mouseenter, mouseleave and click
     * @param event
     */
    clickNav(event) {
      // Do nothing if the event is a click on menu-link
      if (event.type !== 'click' && !event.target.classList.contains('dropdown-item')) {
        // Get the menu element
        const menu = document.querySelector('.drop-menu-lg .dropdown-menu');
        // The menu is already closed, do not trigger
        if (!menu.classList.contains('show') && event.type === 'mouseleave') {
          return;
        }
        event.stopPropagation();
        event.preventDefault();
        // Get the button element and trigger his click event
        const btn = document.querySelectorAll('.drop-menu-lg button')[0];
        btn.click();
      }
    },
    toggleMenu() {
      let hamburger = document.getElementById('hamburger');
      let navMobile = document.getElementById('navigation-mobile');
      let body = document.getElementById('body');
      if (hamburger != null && hamburger.classList.contains('is-active')) {
        hamburger.classList.remove('is-active');
        navMobile.classList.remove('is-active');
        body.classList.remove('mobile-nav-open');
      } else {
        hamburger.classList.add('is-active');
        navMobile.classList.add('is-active');
        body.classList.add('mobile-nav-open');
      }
    },
  },
  watch: {
    '$route' () {
      let hamburger = document.getElementById('hamburger');
      let navMobile = document.getElementById('navigation-mobile');
      let body = document.getElementById('body');
      body.classList.remove('mobile-nav-open');
      if (hamburger != null && hamburger.classList.contains('is-active')) {
        hamburger.classList.remove('is-active');
      }
      if (navMobile != null) {
        navMobile.classList.remove('is-active');
      }
    }
  }
};
</script>

<style lang="scss">
#app {
  display: flex;
  flex-grow: 1;

  .app-content-container {
    padding-top: 60px;
    padding-left: 15px;

    @media screen and (max-width: 768px) {
      padding-left: 0;
    }
  }

  #navigation {
    min-width: 250px;
    min-height: 100vh;
    background-color: white;
    border-right: 2px solid #DBDFE5;
    display: flex;
    flex-direction: column;

    .link-group {
      &:last-child {
        border-top: 2px solid #DBDFE5;
        font-size: 13px;

        .picto {
          width: 25px;
        }
      }
    }

    .logo {
      max-width: 100%;
      padding: 50px 25px 60px 25px;
    }

    .link {
      margin: auto;
      padding: 30px 20px;
      color: #143F73;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      position: relative;
      white-space: nowrap;

      &:hover {
        text-decoration: none;
        color: inherit;
        background-color: #EFF3F8;
      }

      &.router-link-active {
        font-weight: 900;
        color: #005EB8;

        .picto {
          fill: #005EB8;
        }

        &:after {
          content: "";
          display: block;
          height: 2px;
          width: calc(100% - 20px);
          background-color: #005EB8;
          position: absolute;
          bottom: 0;
          left: 10px;
        }
      }

      .picto {
        width: 48px;
        margin-right: 20px;
        fill: #143F73;
      }

      a {
        color: inherit;
      }
    }

    @media screen and (max-width: 768px) {
      width: 0;
      display: none;
    }
  }

  #navigation-mobile {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: white;
    z-index: 101;
    font-size: 26px;
    font-weight: bold;
    padding-top: 100px;

    &.is-active {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;

      @media screen and (min-width: 768px) {
        display: none;
      }
    }

    a {
      margin-bottom: 75px;
    }

  }

  .hamburger {
    display: none;
    position: absolute;
    top: 20px;
    right: 20px;
    z-index: 999;

    @media screen and (max-width: 768px) {
      display: block;
    }
  }
}

body {
  @media screen and (max-width: 768px) {
    padding: 20px;
    &.mobile-nav-open {
      overflow: hidden;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue